<template>
  <div id="count-comment-moderation" v-if="hasCount()">
    <div class="alert alert-dismissible" :class="'alert-' + getLevelPayload()" role="alert" @click="onClick()">
      <div class="d-flex">
        {{ getTitlePayload() }}: {{ count }}
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import { useRouter } from 'vue-router'
import Api from "./services/Api"
import Helper from "@/services/Helper"

export default defineComponent({
  name: "CountCommentModeration",
  components: {},
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter()
    const levels = {
      danger: 'danger',
      muted: 'muted',
    }

    let payload = geyPayload()
    let count = ref(0)

    onMounted(() => {
      let isPrivate = null

      if (payload.typeVisible === 1) {
        isPrivate = true
      }

      if (payload.typeVisible === 2) {
        isPrivate = false
      }

      let query = {
        channel_ids: payload.channelId,
        is_moderate: false,
        is_reject: false,
        is_delst: false,
      }

      if (isPrivate !== null) {
        query.object_is_private = isPrivate
      }

      getCount(query).then((resp) => {
        let result = 0

        Object.values(resp).forEach(val => {
          result += val
        })

        count.value = result
      })
    })

    function isTelegramChannel(channelId) {
      // todo везде такое...
      // todo нужно все это дело привести в порядок
      return Helper.inArray(channelId, [2, 3, 4, 5, 7, 8, 9, 10, 11, 12])
    }

    function isSiteChannel(channelId) {
      return Helper.inArray(channelId, [1])
    }

    function isPromopushkaChannel(channelId) {
      return Helper.inArray(channelId, [13])
    }

    function onClick() {
      if (isTelegramChannel(payload.channelId)) {
        router.push({name: "TelegramComment", query: {'type_visible': payload.typeVisible}})
      } else if (isSiteChannel(payload.channelId)) {
        router.push({name: "SiteComment", query: {'type_visible': payload.typeVisible}})
      } else if (isPromopushkaChannel(payload.channelId)) {
        router.push({name: "PromopushkaComment", query: {'type_visible': payload.typeVisible}})
      } else {
        throw new Error("Неверный канал")
      }
    }

    async function getCount(query) {
      return await Api.count(query)
    }

    function geyPayload() {
      let channelId = null
      let typeVisible = null
      let title = "Комментариев на модерации"
      let level

      if (Helper.inArray([props.payload.type_visible], [1, 2])) {
        typeVisible = props.payload.type_visible
      }

      channelId = props.payload.channel_id

      if (props?.payload?.level === levels.muted) {
        level = levels.muted
      } else {
        level = levels.danger
      }

      if (
          props.payload.title !== "" &&
          props.payload.title !== undefined &&
          props.payload.title !== null
      ) {
        title = props.payload.title
      }

      return {
        channelId,
        typeVisible,
        title,
        level,
      }
    }

    function getTitlePayload() {
      return payload.title
    }

    function getLevelPayload() {
      return payload.level
    }

    function hasCount() {
      return count.value > 0
    }

    return {
      onClick,
      count,
      hasCount,
      getTitlePayload,
      getLevelPayload,
    }
  },
})
</script>

<style scoped>
  #count-comment-moderation .alert {
    font-size: 16px
  }
  #count-comment-moderation .alert:hover {
    cursor: pointer;
  }
</style>
